import { BillingApiEndpoints } from '@contracts';

export const BILLING_ENDPOINTS: BillingApiEndpoints = {
  get: {
    tenants: {
      path: 'billing/tenants/',
    },
    records: {
      path: 'billing/records/',
    },
  },
  create: {
    records: {
      path: 'billing/records/',
    },
  },
};
